import React from "react";
import GoogleMapReact from "google-map-react";
import { Icon } from "antd";

const TOKEN = "AIzaSyDxkSpxLuz_dGanirSXNDuvA_6pDDPJafo";
const Marker = ({ text }) => {
  return (
    <div className="p-pdc-map-marker" style={{ display: "flex" }}>
      <Icon type="environment" theme="twoTone" twoToneColor="#ec841d" />
      <span style={{ fontSize: 10 }}>{text}</span>
    </div>
  );
};

const PdcMap = ({ center, text }) => {
  const gpsIsDefine = center.lng && center.lat;
  const defaultZoom = gpsIsDefine ? 15 : 5;
  const centerDefault = gpsIsDefine ? center : { lat: 46.227638, lng: 2.213749 };
  return (
    <GoogleMapReact bootstrapURLKeys={{ key: TOKEN }} defaultCenter={centerDefault} defaultZoom={defaultZoom}>
      {defaultZoom === 15 && <Marker lng={center.lng} lat={center.lat} text={text}></Marker>}
    </GoogleMapReact>
  );
};

export default PdcMap;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Map.detailpdc.js